<template>
    <div class="form-group--border">
        <div v-if="isLoading">
            Загрузка...
        </div>
        <div v-if="!isLoading && (!items || items.length == 0)">
            Ничего не найдено
        </div>
        <div v-if="!isLoading && items && items.length > 0" class="scrollable-content">
            <dropdown v-for="item in items" :key="item.id">
                <template v-slot:title>
                    <span>Заключение № {{item.number}} от {{$momentFormat(item.passDate, 'DD.MM.YYYY')}}</span>
                </template>
                <template v-slot:text>
                    <span>{{item.educationalProgram.educationLevel.name}}</span>
                </template>
                <template v-slot:default>
                    <div v-if="item">
                        <div class="pmpk-view">
                            <div class="row">
                                <div class="form-group col-3">
                                    <label class="control-label">№ заключения</label>
                                    <ComponentInput v-bind:modelValue="item.number" disabled="true"/>
                                </div>
                                <div class="form-group col-3">
                                    <label class="control-label">Дата прохождения ПМПК</label>
                                    <ComponentInput v-bind:modelValue="$momentFormat(item.passDate, 'DD.MM.YYYY')" disabled="true"/>
                                </div>
                                <div class="form-group col-3">
                                    <label class="control-label">ПМПК</label>
                                    <ComponentInput v-bind:modelValue="item.pmpkPlacement.name" disabled="true"/>
                                </div>
                                <div class="form-group col-3" v-if="item.districtId">
                                    <label class="control-label">Муниципальный район</label>
                                    <ComponentInput v-bind:modelValue="item.district.name" disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Выводы комиссии</label>
                                    <div class="form-control form-control-text">{{item.commissionConclusions}}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-6">
                                    <label class="control-label">Уровень образования</label>
                                    <ComponentInput v-bind:modelValue="item.educationalProgram.educationLevel.name"
                                                    disabled="true"/>
                                </div>
                                <div class="form-group col-6">
                                    <label class="control-label">Образовательная программа</label>
                                    <ComponentInput v-bind:modelValue="item.educationalProgram.name" disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-6">
                                    <label class="control-label">Срок реализации</label>
                                    <ComponentInput v-bind:modelValue="item.realizationTerm.name" disabled="true"/>
                                </div>
                                <div class="form-group col-6">
                                    <label class="control-label">Срок повторного обследования</label>
                                    <ComponentInput v-bind:modelValue="item.repeatPeriod.name" disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Специальные методы обучения</label>
                                    <ComponentInput v-bind:modelValue="item.specialTeachingMethods" disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Специальные учебные пособия и дидактические материалы</label>
                                    <ComponentInput
                                            v-bind:modelValue="item.specialTutorials.map((x)=>x.specialTutorial.name).join('; ')"
                                            disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Специальные ТСО коллективного и индивидуального пользования</label>
                                    <ComponentInput v-bind:modelValue="item.specialTso.map((x)=>x.specialTso.name).join('; ')"
                                                    disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Сопровождение специалистами</label>
                                    <ComponentInput v-bind:modelValue="item.specialists.map((x)=>x.specialist.name).join('; ')"
                                                    disabled="true"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Другие специальные условия</label>
                                    <div class="form-control form-control-text">{{item.specialConditions}}</div>
                                </div>
                            </div>
                            <h5>Рекомендации по психолого-педагогическому и логопедическому сопровождению</h5>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">по педагогическому</label>
                                    <div class="form-control form-control-text">{{item.recomPedagogical.map((x)=>x.recomPedagogical.name).join('; ')}}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">по психологическому</label>
                                    <div class="form-control form-control-text">{{item.recomPsychological.map((x)=>x.recomPsychological.name).join('; ')}}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">по логопедическому</label>
                                    <div class="form-control form-control-text">{{item.recomSpeechTherapy.map((x)=>x.recomSpeechTherapy.name).join('; ')}}</div>
                                </div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="control-label">Рекомендации по прохождению ГИА по ОП основного и среднего общего образования</label>
                                    <div class="form-control form-control-text">{{item.recomGia}}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class='control-label'>Копия заключения</label>
                                        <file-upload width="100%" :entity="item" prop-name="conclusionCopy"  label="Нет файла" readonly="true"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <!-- <label class='control-label'>Информированное согласие родителя на обследование ребенка</label>
                                        <file-upload width="100%" :entity="item" prop-name="parentConsent" label="Нет файла" readonly="true"/> -->
                                        <label class='control-label'>Согласие на добавление заключения ПМПК в Регистр ЛРАС</label>
                                        <file-upload width="100%" :entity="item" prop-name="consentToAdd" label="Нет файла" readonly="true"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-12">
                                        <label class="control-label">Иные документы</label>
                                        <div v-if="!item.files?.length">Нет прикрепленных файлов</div>
                                        <div v-else class="d-flex flex-column">
                                            <div v-for="file in item.files">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-column">
                                                        <file-upload :entity="file" prop-name="file" readonly="true"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </dropdown>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import Dropdown from "@/modules/journal/components/Dropdown";
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import Api from "../api/ras";
  import ComponentInput from "@/common/components/ComponentInput";
  import FileUpload from "@/common/components/FileUpload";
  export default {
    name: "PmpkConclusionActive",
    components: {FileUpload, ComponentInput, ButtonComponent, Dropdown},
    props: {
      patientId: {
        type: Number
      }
    },
    data() {
      return {
        items: [],
        isLoading: true
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        Api.getPmpkConclusionActiveList(this.patientId)
          .then((response) => {
            this.items = response.data;
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      close() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
    .scrollable-content {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
    }
    .pmpk-view {
        max-width: 98%;
    }
    .form-control-text {
        height: auto;
        background: #F5F5FA;
        min-height: calc(2.25rem + 2px);
    }
</style>